import {
  SummaryMetric,
  APPLICATION_SUMMARY,
  VM_SUMMARY,
} from '@/components/Home/utils/custom.home.types.js';
import {
  CAPABILITY_APM,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
  CAPABILITY_VM,
} from '@/utils/constants';
import { SubTypes } from '@/utils/capabilties/vm/constatnts';

export const applicationSmryWidget = {
  id: APPLICATION_SUMMARY,
  serviceKey: '',
  serviceName: '',
  chartType: SummaryMetric,
};

export const vmSmryWidget = {
  id: VM_SUMMARY,
  serviceKey: '',
  serviceName: '',
  chartType: SummaryMetric,
};

const apmMetricList = [
  { metricName: 'service_resp_time', aggregatorType: 'Avg' },
  { metricName: 'service_total_call', aggregatorType: 'Sum' },
  { metricName: 'service_error_count', aggregatorType: 'Sum' },
  { metricName: 'service_apdex', aggregatorType: 'Sum' },
  // TODO: Need to add missing - Errors per min, Calls per min & Total Alerts triggered
];

const bmMetricList = [
  { metricName: 'browser_app_resp_time', aggregatorType: 'Avg' },
  // {metricName: 'service_total_call', aggregatorType: 'Sum'},
  { metricName: 'browser_app_error_sum', aggregatorType: 'Sum' },
  { metricName: 'browser_app_error_rate', aggregatorType: 'Sum' },
  { metricName: 'browser_app_apdex', aggregatorType: 'Sum' },
  // TODO: Need to add missing -  total calls, Calls per min & Total Alerts triggered
];

const mmMetricList = [
  { metricName: 'mobile_app_perf_response_time', aggregatorType: 'Avg' },
  // {metricName: 'service_total_call', aggregatorType: 'Sum'},
  { metricName: 'mobile_app_perf_error_sum', aggregatorType: 'Sum' },

  // TODO: Need to add missing - total calls, Errors per min, Calls per min & Total Alerts triggered
];

const vmWindowsMetricList = [
  { metricName: 'windows_vm_cpu_usage_percentage', aggregatorType: 'Per' },
  { metricName: 'windows_vm_memory_usage_used_bytes', aggregatorType: 'Per' },
  { metricName: 'windows_vm_disk_utility_used_bytes', aggregatorType: 'Sum' },
  // TODO: Need to add missing
];

const vmLinuxMetricList = [
  { metricName: 'meter_vm_cpu_average_used', aggregatorType: 'Per' },
  { metricName: 'meter_vm_memory_used', aggregatorType: 'Per' },
  // TODO: Need to add missing
];
// TODO: Remove unused decleration post verification.
const getMetricNames = (capability, subType) => {
  switch (capability) {
    case CAPABILITY_APM:
      return apmMetricList;
    case CAPABILITY_BROWSER:
      return bmMetricList;
    case CAPABILITY_MOBILE:
      return mmMetricList;
    case CAPABILITY_VM:
      return subType === SubTypes.WINDOWS
        ? vmWindowsMetricList
        : vmLinuxMetricList;
  }
};

export const getSummaryWidget = ({
  widgetName,
  serviceKey,
  capability,
  serviceName,
  chartType = SummaryMetric,
  entityType = 'Service',
}) => ({
  serviceKey,
  serviceName,
  chartType,
  capability,
  entityType,
  widgetName,
});

const graphs = {
  lineCharts: [
    {
      id: 'apm_load',
      width: '48%',
      title: 'Service load',
      header: {
        title: 'Load',
        titleIcon: '',
        content: [],
      },
      serviceKey: '',
      serviceName: '',
      capability: 'APM',
      chartColor: ['#008FFB'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'service_total_call' }],
      queryMetricType: 'readMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'Number of calls',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      id: 'apm_error',
      width: '48%',
      title: 'Error',
      header: {
        title: 'Error',
        titleIcon: 'error',
        content: [],
        isError: true,
        hidePercentageParam: true,
      },
      serviceKey: '',
      serviceName: '',
      capability: 'APM',
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'service_error_count' }],
      queryMetricType: 'readMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of errors',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'apm_resp',
      width: '48%',
      title: 'Service avg response time',
      header: {
        title: 'Response time',
        titleIcon: 'responseTime',
        content: [],
        displayOnlyUnit: true,
      },
      serviceKey: '',
      serviceName: '',
      capability: 'APM',
      chartColor: ['#98ED78'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'service_resp_time' }],
      queryMetricType: 'readMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'ms average',
      axisLabels: {
        x: 'Time',
        y: 'Response time (ms)',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'apm_resp_per',
      width: '48%',
      widthInPer: '100%',
      title: 'Service percentile response time',
      height: '12.5em',
      header: {
        title: 'Percentile response time',
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      serviceKey: '',
      serviceName: '',
      capability: 'APM',
      chartColor: ['#5CA8FF', '#0DCEBF', '#FFCC55', '#A0A7E6', '#EA7699'],
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: [{ metricName: 'service_percentile' }],
      queryMetricType: 'readLabeledMetricsValues',
      chartType: 'ApexChartArea',
      unit: 'ms',
      metricLabels: 'P50, P75, P90, P95, P99',
      labelsIndex: '0, 1, 2, 3, 4',
      axisLabels: {
        x: 'Time',
        y: 'Percentile response time (ms)',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'browser_load',
      width: '48%',
      title: 'Service instance load',
      header: {
        title: 'Load',
        titleIcon: '',
        content: [],
        displayCustomButton: false,
      },
      capability: 'BROWSER',
      chartColor: ['#008FFB'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'browser_app_pv' }],
      queryMetricType: 'readMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'CPM - calls per minute',
      axisLabels: {
        x: 'Time',
        y: 'Number of calls',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'CPM',
      },
    },
    {
      id: 'browser_load_time',
      width: '48%',
      title: 'Service load',
      header: {
        title: 'Load time',
        titleIcon: '',
        content: [],
        displayOnlyUnit: true,
        displayCustomButton: false,
      },
      capability: 'BROWSER',
      chartColor: ['#98ED78'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'browser_app_resp_time' }],
      queryMetricType: 'readMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'ms average',
      axisLabels: {
        x: 'Time',
        y: 'Response time (ms)',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'browser_error',
      width: '48%',
      title: 'Error',
      header: {
        title: 'Error',
        titleIcon: 'error',
        content: [],
        isError: true,
        hidePercentageParam: true,
        displayCustomButton: false,
      },
      capability: 'BROWSER',
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'browser_app_error_sum' }],
      queryMetricType: 'readMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of errors',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },

    /**
     *
     *    Mobile Monitoring Crashes Custom Graphs Configs
     */
    {
      id: 'mobile_app_crash_count',
      width: '48%',
      isCrashes: true,
      title: 'Mobile app crashes',
      header: {
        title: 'Mobile app crashes',
        titleIcon: 'Mobile App Crashes',
        content: [],
        HideCenterMiscContent: true,
      },
      capability: 'MOBILE',
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'mobile_app_crash_count' }],
      queryMetricType: 'readMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of crashes',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_crash_affected_users',
      width: '48%',
      isCrashes: true,
      title: 'Crash affected users',
      filterType: 'User',
      header: {
        title: 'Crash affected users',
        titleIcon: 'Crash Affected Users',
        content: [],
        HideCenterMiscContent: true,
      },
      capability: 'MOBILE',
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'crashByFilter',
      metricName: [{ metricName: 'crashByFilter' }],
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of crashes',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_crashes_by_os',
      width: '48%',
      isCrashes: true,
      widthInPer: '100%',
      title: 'Crashes by OS',
      height: '12.5em',
      header: {
        title: 'Crash affected users',
        titleIcon: 'Crash Affected Users',
        content: [],
        HideCenterMiscContent: true,
      },
      showLegendForSingle: true,
      serviceKey: '',
      serviceName: '',
      capability: 'MOBILE',
      filterType: 'Os',
      metricLabels: 'iOS, Android',
      chartColor: ['#5CA8FF', '#0DCEBF'],
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: [{ metricName: '-' }],
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'crashByFilter',
      chartType: 'ApexChartAreaCustom',
      unit: 'ms',
      labelsIndex: '0, 1',
      axisLabels: {
        x: 'Time',
        y: 'Number of crashes',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_crashes_by_app_version',
      width: '48%',
      widthInPer: '100%',
      isCrashes: true,
      title: 'Crashes by OS',
      height: '12.5em',
      header: {
        title: 'Crashes by app versions',
        titleIcon: 'Crashes By App Versions',
        content: [],
        HideCenterMiscContent: true,
      },
      showLegendForSingle: true,
      serviceKey: '',
      serviceName: '',
      capability: 'MOBILE',
      filterType: 'AppVersion',
      metricLabels: 'iOS, Android',
      chartColor: ['#5CA8FF', '#0DCEBF'],
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: [{ metricName: '-' }],
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'crashByFilter',
      chartType: 'ApexChartAreaCustom',
      unit: 'ms',
      labelsIndex: '0, 1',
      axisLabels: {
        x: 'Time',
        y: 'Number of crashes',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_crashes_by_device',
      width: '48%',
      isCrashes: true,
      widthInPer: '100%',
      title: 'Crashes by OS',
      height: '12.5em',
      header: {
        title: 'Crashes by app versions',
        titleIcon: 'Crashes By App Versions',
        content: [],
        HideCenterMiscContent: true,
      },
      showLegendForSingle: true,
      serviceKey: '',
      serviceName: '',
      capability: 'MOBILE',
      filterType: 'Device',
      metricLabels: 'iOS, Android',
      chartColor: ['#5CA8FF', '#0DCEBF'],
      entityType: 'Service',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: [{ metricName: '-' }],
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'crashByFilter',
      chartType: 'ApexChartAreaCustom',
      unit: 'ms',
      labelsIndex: '0, 1',
      axisLabels: {
        x: 'Time',
        y: 'Number of crashes',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    /**
     *
     *    Mobile Monitoring Performance Custom Graphs Configs
     */
    {
      id: 'mobile_app_normal_count',
      width: '48%',
      isPerformance: true,
      isPerformanceGraph: true,
      title: 'Number of requests',
      header: {
        title: 'Number of requests',
        titleIcon: 'Number of Requests',
        content: [],
        basicInfoStyling: true,
      },
      capability: 'MOBILE',
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'mobile_app_normal_count' }],
      queryMetricType: 'readMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of requests',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_app_perf_response_time',
      width: '48%',
      isPerformanceResponseTime: true,
      isPerformanceGraph: true,
      title: 'HTTP response time',
      header: {
        title: 'HTTP response time',
        titleIcon: 'HTTP Response Time',
        content: [],
        HideCenterMiscContent: true,
      },
      capability: 'MOBILE',
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Service',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'mobile_app_perf_response_time' }],
      queryMetricType: 'readMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'ms',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_app_perf_error_sum',
      width: '48%',
      isPerformanceGraph: true,
      title: 'Error rate',
      header: {
        title: 'Error rate',
        titleIcon: 'Error Rate',
        content: [],
        isError: true,
      },
      capability: 'MOBILE',
      chartColor: ['#FF0000'],
      height: '12.5em',
      entityType: 'Mobile',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'mobile_app_perf_error_sum' }],
      queryMetricType: 'readCustomMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of errors',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_app_perf_user_impacted',
      width: '48%',
      isPerformanceGraph: true,
      title: 'Users impacted by errors',
      header: {
        title: 'Users impacted by errors',
        titleIcon: 'Users Impacted by Errors',
        content: [],
        HideCenterMiscContent: true,
      },
      capability: 'MOBILE',
      chartColor: ['#F5FF00'],
      height: '12.5em',
      entityType: 'Mobile',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'mobile_app_perf_user_impacted' }],
      queryMetricType: 'readCustomMetricsValues',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of errors',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_app_usage_active_session',
      width: '48%',
      isUsages: true,
      title: 'Active sessions',
      header: {
        title: 'Active sessions',
        titleIcon: 'Active Sessions',
        content: [],
        HideCenterMiscContent: true,
      },
      capability: 'MOBILE',
      chartColor: ['#98ED78'],
      height: '12.5em',
      entityType: 'Mobile',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'mobile' }],
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'activeUsersByOs',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of sessions',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_app_usage_app_launches',
      width: '48%',
      isUsages: true,
      title: 'App launches',
      header: {
        title: 'App launches',
        titleIcon: 'App Launches',
        content: [],
        HideCenterMiscContent: true,
      },
      capability: 'MOBILE',
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'Mobile',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'mobile' }],
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'appEventsByOs',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of app launches',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_app_usage_new_users',
      width: '48%',
      isUsages: true,
      title: 'New users',
      header: {
        title: 'New users',
        titleIcon: 'New Users',
        content: [],
        HideCenterMiscContent: true,
      },
      capability: 'MOBILE',
      chartColor: ['#ed7878'],
      height: '12.5em',
      entityType: 'Mobile',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: [{ metricName: 'mobile' }],
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'newRegisteredUsers',
      chartType: 'ChartLineCustom',
      unit: 'No',
      axisLabels: {
        x: 'Time',
        y: 'Number of users',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_app_usage_by_os',
      width: '48%',
      isCrashes: true,
      widthInPer: '100%',
      title: 'Usage by OS',
      height: '12.5em',
      header: {
        title: 'Usage by OS',
        titleIcon: 'Usage By OS',
        content: [],
        HideCenterMiscContent: true,
      },
      showLegendForSingle: true,
      serviceKey: '',
      serviceName: '',
      capability: 'MOBILE',
      filterType: 'Os',
      metricLabels: 'iOS, Android',
      chartColor: ['#FF056E', '#FF9520'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: [{ metricName: '-' }],
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'usage',
      chartType: 'ApexChartAreaCustom',
      unit: 'ms',
      labelsIndex: '0, 1',
      axisLabels: {
        x: 'Time',
        y: 'Number of users',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_app_usage_by_device',
      width: '48%',
      widthInPer: '100%',
      title: 'Usage by device (Top 5)',
      height: '12.5em',
      header: {
        title: 'Usage by device (Top 5)',
        titleIcon: 'Usage By Device (Top 5)',
        content: [],
        HideCenterMiscContent: true,
      },
      showLegendForSingle: true,
      serviceKey: '',
      serviceName: '',
      capability: 'MOBILE',
      filterType: 'Device',
      metricLabels: 'iOS, Android',
      chartColor: ['#E63A46', '#F843DD', '#FAB025', '#5DC167', '#00CEFF'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: [{ metricName: '-' }],
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'usage',
      chartType: 'ApexChartAreaCustom',
      unit: 'ms',
      labelsIndex: '0, 1, 2, 3, 4',
      axisLabels: {
        x: 'Time',
        y: 'Number of users',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
    {
      id: 'mobile_app_usage_by_app_version',
      width: '48%',
      widthInPer: '100%',
      isCrashes: true,
      title: 'App version distribution (Top 4)',
      height: '12.5em',
      header: {
        title: 'App version distribution (Top 4)',
        titleIcon: 'App Version Distribution (Top 4)',
        content: [],
        HideCenterMiscContent: true,
      },
      showLegendForSingle: true,
      serviceKey: '',
      serviceName: '',
      capability: 'MOBILE',
      filterType: 'AppVersion',
      metricLabels: 'iOS, Android',
      chartColor: ['#E63A46', '#F843DD', '#FAB025', '#5DC167', '#00CEFF'],
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'LABELED_VALUE',
      metricName: [{ metricName: '-' }],
      queryMetricType: 'readMobileCustomMetricsValues',
      customMetricName: 'usage',
      chartType: 'ApexChartAreaCustom',
      unit: 'ms',
      labelsIndex: '0, 1, 2, 3, 4',
      axisLabels: {
        x: 'Time',
        y: 'Number of users',
      },
      labels: {
        xAxis: 'Time',
        yAxis: 'ms',
      },
    },
  ],
};

export default graphs;
